<div class="container mt-2 mt-sm-4">
  <a class="navbar-brand" href="/">
    <img src="/POSH_Logo_suggestion.jpg" />
    <!-- <img src="/POSC_Logo.jpg" /> -->
  </a>
  <!-- <div class="navbar-brand">Polar Observing Site Discovery Tool</div> -->
  <div class="d-flex flex-row ms-auto">
    <a class="navbar-brand" target="_blank"
       href="https://arcticobserving.org">
      <img src="/SAON_logo_2023.png" />
    </a>
    <a class="navbar-brand border-start ps-3" target="_blank"
       href="https://arcticportal.org">
      <img src="/ArcticPortal_white.jpg" />
    </a>
    <a class="navbar-brand border-start ps-2 me-0" target="_blank"
       href="https://www.colorado.edu">
      <img src="/logo_CU_Boulder.png" />
    </a>
  </div>
  <button class="navbar-toggler" type="button"
	  data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
	  aria-controls="navbarCollapse" aria-expanded="false"
	  aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
</div>
<section class="mt-2 mt-sm-4">
  <div class="container collapse navbar-collapse" id="navbarCollapse">
    <ul class="navbar-nav ms-auto">
      <li class="nav-item ms-5 ms-sm-4 ms-md-5"
	  [class]="id() == 'home' ? 'active' : ''">
	<a class="nav-link" routerLink="/">Home</a>
	<div></div>
      </li>
      <li class="nav-item ms-5 ms-sm-4 ms-md-5"
	  [class]="id() == 'faq' ? 'active' : ''">
	<a class="nav-link" routerLink="/faq">FAQ</a>
	<div></div>
      </li>
      <li class="nav-item ms-5 ms-sm-4 ms-md-5"
	  [class]="id() == 'contact' ? 'active' : ''">
	<a class="nav-link" routerLink="/contact">Contact</a>
	<div></div>
      </li>
      <li class="nav-item ms-5 ms-sm-4 ms-md-5"
	  [class]="id() == 'about' ? 'active' : ''">
	<a class="nav-link" routerLink="/about">About</a>
	<div></div>
      </li>
    </ul>
  </div>
</section>
